export default __webpack_public_path__ + "static/media/unhallowedblight2.c0a7b416.png";